/**
 * Validation constants for file upload in Constancia de Pago workflow.
 */
export const TIPOS_ARCHIVO_VALIDOS = ['image/jpeg', 'image/png', 'application/pdf'];
export const MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB

/**
 * Validates a file for use as a Constancia de Pago.
 * Accepts the file if and only if:
 * - type ∈ {image/jpeg, image/png, application/pdf}
 * - size ≤ 10 MB
 *
 * @param {object} file - File-like object with `type` (string) and `size` (number) properties
 * @returns {{ valid: boolean, error: string | null }}
 */
export function validarArchivo(file) {
  if (!file) {
    return { valid: false, error: 'Debe seleccionar un archivo' };
  }

  if (!TIPOS_ARCHIVO_VALIDOS.includes(file.type)) {
    return { valid: false, error: 'Solo se aceptan archivos JPG, PNG o PDF' };
  }

  if (file.size > MAX_SIZE_BYTES) {
    return { valid: false, error: 'El archivo no debe superar los 10 MB' };
  }

  return { valid: true, error: null };
}
